import { unauthenticatedApi } from "@/lib/api/client";

export interface PurchaseConfirmedRequest {
  amount: number;
  currency?: string;
  email: string;
  invoiceId: string;
  productId: string;
}

/**
 * Fires the Meta Conversions API Purchase event right after Stripe
 * confirms the payment client-side (confirmCardPayment resolved with no error).
 */
export async function sendPurchaseConfirmed(
  data: PurchaseConfirmedRequest,
): Promise<Response> {
  return unauthenticatedApi
    .url("/marketing/purchase-confirmed")
    .post(data)
    .res();
}
